import axios from 'axios';
import moment from 'moment';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Field, reduxForm } from 'redux-form';
import BlockUI from '../../component/BlockUI';
import { RenderDatePicker } from '../../component/formInput';
import Pagination from '../../component/Pagination';
var _ = require('lodash');

const start_date_of_current_month = moment().startOf('month');
const end_date_of_current_month = moment().endOf('month');
const start_date_of_previous_month = moment().subtract(1,'months').startOf('month');
const end_date_of_previous_month = moment().subtract(1,'months').endOf('month');

function DatePicker(from_date, to_date, onDateChange, clearDataFilter) {
 
  return ( 
    <div style={{float: "right"}}>
      <form>
        <div style={{display: 'inline-flex', marginRight:10 }}>
          <span className="input-group-text" style={{height:'fit-content'}}>
            <i style={{ height:20 }} className="icon-calendar22"></i>
          </span>
          <Field
            name="from_date"
            placeholder="dd/mm/yyyy"
            dateFormat="dd/MM/yyyy"
            defaultValue={from_date}
            onChangeAction={(value)=> onDateChange(value, to_date)}
            component={RenderDatePicker}
            />
        </div>
        <div style={{display: 'inline-flex', marginRight:10 }}>
          <span className="input-group-text" style={{height:'fit-content'}}>
            <i style={{ height: 20 }} className="icon-calendar22"></i>
          </span>
          <Field
            name="to_date"
            placeholder="dd/mm/yyyy"
            dateFormat="dd/MM/yyyy"
            defaultValue={to_date}
            onChangeAction={(value)=>onDateChange(from_date, value)}
            component={RenderDatePicker}/>
        </div>
        <div style={{display: 'inline-flex',height:'fit-content'}}>
          <button onClick={()=> clearDataFilter()} style={{whiteSpace:'nowrap', width:'inherit'}} className="btn btn-warning">x</button>
        </div>
      </form>
    </div>
  )
}

function TicketRateRows(data) {
  const inner_rows = _.map(data, function(i, index) {
    return (
      <tr key={index} className={i.amount < 0 ? "alpha-orange" : ""} style={{borderBottom: "1px solid #ddd"}}>
        <td>
          {i.employee.full_name}
          <br/>
          <small>{i.employee.email}</small>
        </td>
        <td>
          {i.total_score}
        </td>
      </tr>
      )
  })
  return inner_rows;
}

class TicketRateReport extends React.Component {
  constructor(props) {
    const {account_type} = props.routeProps.match.params;
    super(props);
    this.state = {
      table_data: [],
      table_query: {
				from_date: moment(start_date_of_current_month).format("YYYY-MM-DD 00:00:00"),
        to_date: moment(end_date_of_current_month).format("YYYY-MM-DD 23:59:59")
      },
      is_loading: true
    }
  }

  componentDidMount() {
    this.reload(this.state.table_query);
  }

  reload = (table_query) => {
    const self = this;

    axios({
      method: 'post',
      url: window.api_url + '/admin/api/report/ticket_score/list',
      withCredentials: true,
      data: table_query
    }).then(function (response) {
      self.setState({
        ...self.state,
        table_query: table_query,
        table_data: response.data.data,
        is_loading: false
      })
    });
  }

  onDateChange = (from_date, to_date) => {
    const table_query = {
      ...this.state.table_query,
      search_value: "",
      current_page: 1,
      from_date: moment(from_date).format("YYYY-MM-DD hh:mm:ss"),
      to_date: moment(to_date).format("YYYY-MM-DD hh:mm:ss")
    };
    this.setState({
      ...this.state,
      table_query: table_query,
      is_loading: true
    });

    if(from_date && to_date) {
      this.reload(table_query);
    }
  }

  clearDataFilter = () => {
    const { reset } = this.props;
    const table_query = {
      ...this.state.table_query,
      search_value: "",
      current_page: 1,
      from_date: null,
      to_date: null,
      account_type: "all"
    };
    this.setState({
      ...this.state,
      table_query: table_query,
      is_loading: true
    });
    reset();
    this.reload(table_query);
  }

  onKeyPess = (key_code) => {
    const { history, role_path } = this.props;
    if (key_code == "Escape") {
      history.push(role_path + "/report/ticket_score/list")
      this.clearDataFilter();
    }
  }

  render() {
    const { table_query, table_data, is_loading } = this.state;
    return(
      <React.Fragment>
        {is_loading && <BlockUI />}
        <div className="page-header">
          <div className="page-header-content header-elements-md-inline">
            <div className="page-title d-flex">
              <h4>
                <i className="icon-paragraph-justify2 mr-2"></i>
                <span className="text-semibold">Thống kê điểm đánh giá hỗ trợ</span>
              </h4>
            </div>
          </div>
        </div>
        <br/>
        <div className="row">
          <div className="col-md-12">
            <div className="card card-body">
              <div className="row">
                <div className="col-md-6">
                </div>
                <div className="col-md-6">
                  {DatePicker(table_query.from_date, table_query.to_date, this.onDateChange, this.clearDataFilter)}
                  <center>
                    <div style={{display: 'inline-flex', marginRight:10 }}>
                      <button onClick={() => this.onDateChange(start_date_of_previous_month, end_date_of_previous_month)} className="badge badge-secondary" style={{marginRight: 10 }}> Tháng Trước </button>
                      <button onClick={() => this.onDateChange(start_date_of_current_month, end_date_of_current_month)} className="badge badge-success"> Tháng Hiện Tại </button>
                    </div>
                  </center>
                </div>
              </div>
              <div className="table-responsive">
                <table className="table table-togglable table-hover default footable-loaded footable">
                  <thead>
                  <tr>
                    <th data-toggle="true" className="footable-visible footable-first-column">
                      Tên
                      <br/>
                      <small className="display-block text-muted text-size-small">Email</small></th>
                    <th>Tổng Số Điểm</th>
                  </tr>
                  </thead>
                  <tbody>
                    {table_data && TicketRateRows(table_data)}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    )
  }
}

const mapState = state => ({
  role_path: state.userProfile.role_path,
});

const mapDispatch = (dispatch) => ({

});

const TicketRateReportWrapper = reduxForm({
  form: 'TicketRateReport',
  destroyOnUnmount: true,
  enableReinitialize: true,
})(TicketRateReport);

export default connect(mapState, mapDispatch)(withRouter(TicketRateReportWrapper));